module.exports = __webpack_public_path__ + "img/btn-19-manual.edd9cd7e.png";